export const coupons = [
  {
    id: "1",
    url: "https://salt.tikicdn.com/cache/128x128/ts/upload/92/ad/57/0d9a096885400b7b4752b67afdc72898.png",
    price: 25000,
    description: "Cho đơn hàng từ 99K",
    HSD: "30/08/22",
  },
  {
    id: "2",
    url: "https://play-lh.googleusercontent.com/h1C3kl3NetD1IEC4Gq-cwsX2epw0rh0ws4ormMFdZa08CFviKhgnXNRItKa82xdaf9FF",
    price: 30000,
    description: "Cho đơn hàng từ 150K",
    HSD: "15/08/22",
  },
  {
    id: "3",
    url: "https://upload.wikimedia.org/wikipedia/vi/f/fe/MoMo_Logo.png",
    price: 35000,
    description: "Cho đơn hàng từ 200K",
    HSD: "10/08/22",
  },
  {
    id: "4",
    url: "https://cdn.nhanlucnganhluat.vn/uploads/images/ccf3a78f/source/2020-06/101962895_3132004750194424_3118285602814951424_n.jpg",
    price: 45000,
    description: "Cho đơn hàng từ 400K",
    HSD: "15/08/22",
  },
  {
    id: "5",
    url: "https://play-lh.googleusercontent.com/Q874CkbeX3wp72FaPE-MxGhvkiPOVrpQwNSlYA4za6_WmftSHi4arWI--s5zHF7oejE",
    price: 50000,
    description: "Cho đơn hàng từ 500K",
    HSD: "25/08/22",
  },
  {
    id: "6",
    url: "https://salt.tikicdn.com/cache/128x128/ts/upload/92/ad/57/0d9a096885400b7b4752b67afdc72898.png",
    price: 80000,
    description: "Áp dụng cho đơn hàng 1000K",
    HSD: "30/08/22",
  },
];
